var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"value":_vm.sideviewName}},[_c(_vm.sideviewName,{tag:"component",attrs:{"payload":_vm.sideviewPayload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }